import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
    agreements: false,
    agreementsDescriptions: false,
    agreementsRegions: false,

    attributes: false,
    attributesCategories: false,
    attributesColorValues: false,
    attributesDictionaryValues: false,
    attributesEdit: false,
    attributesSettings: false,

    categories: false,
    categoriesBasic: false,
    categoriesMetatags: false,
    categoriesImage: false,

    countries: false,
    currencies: false,
    currenciesRegions: false,
    customPages: false,
    popups: false,

    discountGroups: false,
    discountUsers: false,
    discounts: false,
    discountsCategories: false,
    discountsCodes: false,
    discountsCountries: false,
    discountsProducts: false,
    discountsRegions: false,

    exchangeRates: false,
    manufacturers: false,
    orders: false,

    products: false,
    shipments: false,
    payments: false,
    productsBasic: false,
    productsDescriptions: false,
    productsImages: false,
    productsMetatags: false,
    productsAttributes: false,
    productsPrices: false,
    productReviews: false,
    productPageTabs: false,
    productsAlternative: false,
    productsRelated: false,
    productsAdditionalCategories: false,
    fillers: false,
    fillerToEdit: false,

    sessionTimeout: false,

    regionCountries: false,
    regions: false,

    homePageProducts: false,
    homePageBanner: false,
    homePageAnimatedBanner: false,
    homePageAnimatedBannerImages: false,
    homePagePromoSections: false,
    homePageSections: false,
    homePageSectionPhotoText: false,

    emailTemplates: false,
    emailTemplateTables: false,

    visualSettingsCss: false,
    promotionBar: false,
    promotionBarSlides: false,
    visualSettingsLogo: false,
    visualSettingsFavicon: false,
    visualSettingsParams: false,

    productsCategoryAssign: false,

    ceneoSettings: false,
    ceneoMappings: false,

    upperMenu: false,
    bottomMenu: false,

    technicalBreak: false,
    notFound: false,

    notifications: false,
    notificationsList: false,
    userAgreements: false,
    agreementsRegistry: false,

    measures: false,
    productMeasures: false,

    predefinedSearch: false,
    predefinedSearchMetatags: false,

    homePageDoubleImage: false,
    homePageManufacturers: false,

    seoPhotoName: false,
    seoGoogleSiteMap: false,

    footerMain: false,
    cookies: false,
    buttons: false,
    mediaLibrary: false,
    mediaLibraryFile: false,
    mediaLibraryFileEdit: false,
    opinions: false,
    generateToken: false,
    productPrice: false,

    adBanners: false,
    adBannersCategories: false,
    translations: false,
    languages: false,
    productsDeliveryGlobal: false,
    productDelivery: false,

    users: false,
    user: false,

    permissions: false,

    visualSettingsPlaceholderImageProduct: false,

    sectionProducts: false,
    sectionCategories: false,

    emailSettings: false,

    shippingGeneral: false,
    shippingVariants: false,
    shippingWeights: false,
    shippingForms: false,

    paymentForms: false,

    services: false,

    orderStatuses: false,

    categoryFormFields: false,

    payUIntegration: false,

    p24Integration: false,

    productDescriptionImport: false
};

// @ts-nocheck
const refetchers = createSlice({
    name: 'refetchers',
    initialState,
    reducers: {
        setForceRefetchByTarget(state, action) {
            const { target, forceRefetch } = action.payload;
            switch (target) {
                case 'agreements': state.agreements = forceRefetch; break;
                case 'agreementsDescriptions': state.agreementsDescriptions = forceRefetch; break;
                case 'agreementsRegions': state.agreementsRegions = forceRefetch; break;
                case 'attributes': state.attributes = forceRefetch; break;
                case 'attributesCategories': state.attributesCategories = forceRefetch; break;
                case 'attributesColorValues': state.attributesColorValues = forceRefetch; break;
                case 'attributesDictionaryValues': state.attributesDictionaryValues = forceRefetch; break;
                case 'attributesEdit': state.attributesEdit = forceRefetch; break;
                case 'attributesSettings': state.attributesSettings = forceRefetch; break;
                case 'categories': state.categories = forceRefetch; break;
                case 'categoriesBasic': state.categoriesBasic = forceRefetch; break;
                case 'categoriesMetatags': state.categoriesMetatags = forceRefetch; break;
                case 'categoriesImage': state.categoriesImage = forceRefetch; break;
                case 'countries': state.countries = forceRefetch; break;
                case 'currencies': state.currencies = forceRefetch; break;
                case 'currenciesRegions': state.currenciesRegions = forceRefetch; break;
                case 'customPages': state.customPages = forceRefetch; break;
                case 'popups': state.popups = forceRefetch; break;
                case 'discountGroups': state.discountGroups = forceRefetch; break;
                case 'discountUsers': state.discountUsers = forceRefetch; break;
                case 'discounts': state.discounts = forceRefetch; break;
                case 'discountsCategories': state.discountsCategories = forceRefetch; break;
                case 'discountsCodes': state.discountsCodes = forceRefetch; break;
                case 'discountsCountries': state.discountsCountries = forceRefetch; break;
                case 'discountsProducts': state.discountsProducts = forceRefetch; break;
                case 'discountsRegions': state.discountsRegions = forceRefetch; break;
                case 'exchangeRates': state.exchangeRates = forceRefetch; break;
                case 'manufacturers': state.manufacturers = forceRefetch; break;
                case 'orders': state.orders = forceRefetch; break;
                case 'products': state.products = forceRefetch; break;
                case 'shipments': state.shipments = forceRefetch; break;
                case 'payments': state.payments = forceRefetch; break;
                case 'productsBasic': state.productsBasic = forceRefetch; break;
                case 'productsDescriptions': state.productsDescriptions = forceRefetch; break;
                case 'productsImages': state.productsImages = forceRefetch; break;
                case 'productsMetatags': state.productsMetatags = forceRefetch; break;
                case 'productsAttributes': state.productsAttributes = forceRefetch; break;
                case 'productsPrices': state.productsPrices = forceRefetch; break;
                case 'productReviews': state.productReviews = forceRefetch; break;
                case 'productPageTabs': state.productPageTabs = forceRefetch; break;
                case 'productsAlternative': state.productsAlternative = forceRefetch; break;
                case 'productsRelated': state.productsRelated = forceRefetch; break;
                case 'productsAdditionalCategories': state.productsAdditionalCategories = forceRefetch; break;
                case 'fillers': state.fillers = forceRefetch; break;
                case 'fillerToEdit': state.fillerToEdit = forceRefetch; break;
                case 'sessionTimeout': state.sessionTimeout = forceRefetch; break;
                case 'regionCountries': state.regionCountries = forceRefetch; break;
                case 'regions': state.regions = forceRefetch; break;
                case 'homePageProducts': state.homePageProducts = forceRefetch; break;
                case 'homePageBanner': state.homePageBanner = forceRefetch; break;
                case 'homePageAnimatedBanner': state.homePageAnimatedBanner = forceRefetch; break;
                case 'homePageAnimatedBannerImages': state.homePageAnimatedBannerImages = forceRefetch; break;
                case 'homePagePromoSections': state.homePagePromoSections = forceRefetch; break;
                case 'homePageSections': state.homePageSections = forceRefetch; break;
                case 'homePageSectionPhotoText': state.homePageSectionPhotoText = forceRefetch; break;
                case 'emailTemplates': state.emailTemplates = forceRefetch; break;
                case 'emailTemplateTables': state.emailTemplateTables = forceRefetch; break;
                case 'visualSettingsCss': state.visualSettingsCss = forceRefetch; break;
                case 'promotionBar': state.promotionBar = forceRefetch; break;
                case 'promotionBarSlides': state.promotionBarSlides = forceRefetch; break;
                case 'visualSettingsLogo': state.visualSettingsLogo = forceRefetch; break;
                case 'visualSettingsFavicon': state.visualSettingsFavicon = forceRefetch; break;
                case 'visualSettingsParams': state.visualSettingsParams = forceRefetch; break;
                case 'productsCategoryAssign': state.productsCategoryAssign = forceRefetch; break;
                case 'ceneoSettings': state.ceneoSettings = forceRefetch; break;
                case 'ceneoMappings': state.ceneoMappings = forceRefetch; break;
                case 'upperMenu': state.upperMenu = forceRefetch; break;
                case 'bottomMenu': state.bottomMenu = forceRefetch; break;
                case 'technicalBreak': state.technicalBreak = forceRefetch; break;
                case 'notFound': state.notFound = forceRefetch; break;
                case 'notifications': state.notifications = forceRefetch; break;
                case 'notificationsList': state.notificationsList = forceRefetch; break;
                case 'userAgreements': state.userAgreements = forceRefetch; break;
                case 'agreementsRegistry': state.agreementsRegistry = forceRefetch; break;
                case 'measures': state.measures = forceRefetch; break;
                case 'productMeasures': state.productMeasures = forceRefetch; break;
                case 'predefinedSearch': state.predefinedSearch = forceRefetch; break;
                case 'predefinedSearchMetatags': state.predefinedSearchMetatags = forceRefetch; break;
                case 'homePageDoubleImage': state.homePageDoubleImage = forceRefetch; break;
                case 'homePageManufacturers': state.homePageManufacturers = forceRefetch; break;
                case 'seoPhotoName': state.seoPhotoName = forceRefetch; break;
                case 'seoGoogleSiteMap': state.seoGoogleSiteMap = forceRefetch; break;
                case 'footerMain': state.footerMain = forceRefetch; break;
                case 'cookies': state.cookies = forceRefetch; break;
                case 'buttons': state.buttons = forceRefetch; break;
                case 'mediaLibrary': state.mediaLibrary = forceRefetch; break;
                case 'mediaLibraryFile': state.mediaLibraryFile = forceRefetch; break;
                case 'mediaLibraryFileEdit': state.mediaLibraryFileEdit = forceRefetch; break;
                case 'opinions': state.opinions = forceRefetch; break;
                case 'generateToken': state.generateToken = forceRefetch; break;
                case 'productPrice': state.productPrice = forceRefetch; break;
                case 'adBanners': state.adBanners = forceRefetch; break;
                case 'adBannersCategories': state.adBannersCategories = forceRefetch; break;
                case 'translations': state.translations = forceRefetch; break;
                case 'languages': state.languages = forceRefetch; break;
                case 'productsDeliveryGlobal': state.productsDeliveryGlobal = forceRefetch; break;
                case 'productDelivery': state.productDelivery = forceRefetch; break;
                case 'users': state.users = forceRefetch; break;
                case 'user': state.user = forceRefetch; break;
                case 'permissions': state.permissions = forceRefetch; break;
                default: break;
            }
        },
    },
});

export const { setForceRefetchByTarget } = refetchers.actions;

export default refetchers.reducer;
